import { API_BASE_URL } from "../config"

async function parseError(response: Response) {
  try {
    const payload = await response.json()
    return payload.detalle || "Ocurrió un error inesperado."
  } catch {
    return "Ocurrió un error inesperado."
  }
}

export type TrackingDetail = {
  id: number
  tracking_id: string
  beneficio_id: number
  beneficio: string
  estado: string
  descripcion: string
  fecha_solicitud: string
  archivos: {
    file_name: string
    file_size: string
    upload_date: string
  }[]
  resolucion: {
    decision: string
    justificacion: string
    fecha: string
  } | null
}

export async function getRequestTrackingDetails(token: string, requestId: number): Promise<TrackingDetail> {
  const response = await fetch(`${API_BASE_URL}/tracking/requests/${requestId}`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  })
  
  if (!response.ok) {
    throw new Error(await parseError(response))
  }
  
  return response.json()
}
